import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center h-screen w-screem" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Redirecting home ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Icon, {
      icon: ['fab', 'twitter'],
      class: "flash-animation",
      style: {'width': '4rem', 'height': '4rem'}
    }),
    _hoisted_2
  ]))
}